import { makeStyles } from '@material-ui/core/styles';

export default () => {
  return makeStyles(theme => ({
    button: {
      height: "55px",
      borderRadius: "0 10px 10px 0"
    },
    titlePopover: {
      fontWeight: "bold"
    },
    itemButtonBar: {
      width: "250px",
      marginTop: '12px'
    }
  }));
};
